const initialState = {
    isAuthenticated: false,
    categories: [],
    subjects: {},
    autocomplete: [],
    completedStages: [],
    selectedPackage: null,
    packages: [],
    countryDetails: null,
    countries: {},
    geoLocationData: null,
    currency: null,
    countrySettings: null,
};

export default function generalReducer(state = initialState, action) {
    switch (action.type) {
        case 'USER_SMS_AUTHENTICATED': {
            return {
                ...state,
                isAuthenticated: true
            }
        }
        case 'ADD_CATEGORIES': {
            return {
                ...state,
                categories: action.data
            }
        }
        case 'ADD_CATEGORY_SUBJECT': {
            return {
                ...state,
                subjects: {
                    ...state.subjects,
                    ...action.data
                }
            }
        }
        case 'ADD_AUTOCOMPLETE': {
            return {
                ...state,
                autocomplete: action.data
            }
        }
        case 'SET_STAGE_COMPLETED': {
            return {
                ...state,
                completedStages: [...state.completedStages, action.stage]
            }
        }
        case 'SET_SELECTED_PACKAGE': {
            return {
                ...state,
                selectedPackage: action.selectedPackage
            }
        }
        case 'SET_PACKAGES': {
            return {
                ...state,
                packages: action.packages
            }
        }
        case 'SET_GEOLOCATION_DATA': {
            return {
                ...state,
                geoLocationData: action.geoLocationData
            }
        }
        case 'SET_COUNTRY_DETAILS': {
            return {
                ...state,
                countryDetails: action.payload.countryDetails,
                currency: action.payload.currency,
                countrySettings: action.payload.countrySettings,
            }
        }
        case 'SET_COUNTRIES': {
            return {
                ...state,
                countries: action.countries
            }
        }
        default: {
            return state
        }
    }
}
